import { render, staticRenderFns } from "./RightMenuDraft_Ap.vue?vue&type=template&id=4de3ef3d&scoped=true"
import script from "./RightMenuDraft_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuDraft_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuDraft_Ap.vue?vue&type=style&index=0&id=4de3ef3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de3ef3d",
  null
  
)

export default component.exports